// Eventos personalizados por clic (§12): cualquier enlace o botón con data-analytics-event.
// Los datos salen de atributos data-analytics-*; nunca datos personales ni de salud.
document.addEventListener('click', (event) => {
  const el = event.target.closest('[data-analytics-event]');
  if (!el) return;
  const data = {};
  for (const [key, value] of Object.entries(el.dataset)) {
    if (key.startsWith('analytics') && key !== 'analyticsEvent') data[key.slice(9).replace(/^./, (c) => c.toLowerCase())] = value;
  }
  window.Shopify?.analytics?.publish?.(`pawly:${el.dataset.analyticsEvent}`, data);
});
